import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
export default /*#__PURE__*/ _defineComponent({
    __name: 'RefreshModal',
    setup(__props) {
        const store = useStore();
        const showModal = ref(false);
        const isForHandover = ref(false);
        const refreshBooking = computed(() => store.state.global.refreshBooking);
        const refreshHandover = computed(() => store.state.global.refreshHandover);
        const changesForText = computed(() => (isForHandover.value ? 'handover' : 'booking'));
        watch(refreshBooking, (value) => {
            showModal.value = value;
        });
        watch(refreshHandover, (value) => {
            showModal.value = value;
            isForHandover.value = true;
        });
        function onAction() {
            window.location.reload();
        }
        return (_ctx, _cache) => {
            const _component_b_col = _resolveComponent("b-col");
            const _component_b_row = _resolveComponent("b-row");
            const _component_b_button = _resolveComponent("b-button");
            const _component_b_modal = _resolveComponent("b-modal");
            return (_openBlock(), _createBlock(_component_b_modal, {
                modelValue: showModal.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((showModal).value = $event)),
                title: "New Details",
                "header-class": "col12 bg-primary text-white text-center closeButton",
                "title-class": "w-100",
                "hide-footer": "",
                centered: "",
                "no-close-on-backdrop": "",
                "hide-header-close": ""
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_b_row, { class: "justify-content-center" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_b_col, {
                                cols: "12",
                                class: "text-center"
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("p", null, " Some changes have been made to this " + _toDisplayString(changesForText.value) + ". Please refresh the page to ensure you have the latest information. ", 1)
                                ], undefined, true),
                                _: 1
                            })
                        ], undefined, true),
                        _: 1
                    }),
                    _createVNode(_component_b_row, { class: "justify-content-center mt-3" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_b_col, { cols: "4" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_b_button, {
                                        variant: "primary",
                                        block: "",
                                        onClick: onAction
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode("Refresh Page")
                                        ], undefined, true),
                                        _: 1
                                    })
                                ], undefined, true),
                                _: 1
                            })
                        ], undefined, true),
                        _: 1
                    })
                ]),
                _: 1
            }, 8, ["modelValue"]));
        };
    }
});
